import React from 'react';
import { SectionDivider } from '../components/SectionDivider';
import { BlogCard } from '../components/BlogCard';
export function BlogIndex() {
  const posts = [{
    title: 'How Much Does A Website Cost In Ireland In 2026?',
    excerpt: 'From DIY builders to expensive agencies, we break down the real costs of getting online in Ireland today.',
    slug: 'website-cost-ireland-2026',
    date: 'October 15, 2025',
    readTime: '8 min read'
  }, {
    title: 'Website Design Dublin: What Small Businesses Must Know',
    excerpt: 'A complete guide for Dublin business owners on choosing the right web design partner and avoiding costly mistakes.',
    slug: 'website-design-dublin-small-businesses',
    date: 'October 10, 2025',
    readTime: '6 min read'
  }, {
    title: 'Why Every Electrician In Dublin Needs A Website',
    excerpt: "Word of mouth isn't enough anymore. Learn how a professional website gets you more emergency calls and bigger jobs.",
    slug: 'electrician-website-dublin',
    date: 'October 5, 2025',
    readTime: '5 min read'
  }, {
    title: 'Restaurant Website Design Ireland: How To Get More Bookings',
    excerpt: 'Stop paying high commissions to third-party apps. Drive direct bookings with a website designed for conversion.',
    slug: 'restaurant-website-design-ireland',
    date: 'September 28, 2025',
    readTime: '7 min read'
  }, {
    title: 'SEO For Small Businesses In Ireland Explained Simply',
    excerpt: 'Demystifying SEO for Irish SMEs. Practical tips to help your local business rank higher on Google.',
    slug: 'seo-small-businesses-ireland',
    date: 'September 20, 2025',
    readTime: '9 min read'
  }];
  return <div className="min-h-screen bg-[#050505] text-white pt-24" data-id="element-921">
      <section className="py-16 px-4 md:px-6" data-id="element-922">
        <div className="max-w-4xl mx-auto text-center mb-16 reveal" data-id="element-923">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-924">
            Website Design Dublin —{' '}
            <span className="gold-gradient-text" data-id="element-925">Blog & Resources</span>
          </h1>
          <p className="text-xl text-white/70 max-w-2xl mx-auto" data-id="element-926">
            Tips, guides, and insights for Irish business owners looking to grow
            online.
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 reveal" data-id="element-927">
          {posts.map((post, idx) => <BlogCard key={idx} {...post} data-id="element-928" />)}
        </div>
      </section>

      <SectionDivider data-id="element-929" />
    </div>;
}